import styled from 'styled-components';

type ContainerLoadingProps = {
    backgroundWhite: boolean;
};

export const ContainerLoading = styled.div<ContainerLoadingProps>`
    inset: 0;
    z-index: 101;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme, backgroundWhite }) =>
        backgroundWhite ? theme.colors.primary : 'rgba(0, 0, 0, 0.4)'};
`;
